// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__tYl7J","logo":"LoginPage_logo__kAVys","form":"LoginPage_form__m8Bii","btn":"LoginPage_btn__7g+8A"};